/* eslint-disable no-prototype-builtins */
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'

export const standardToggle = (optionsArray, name, value, changeHandler, buttonWidth, setErrors, setForm, form) => {
  return (
    <>
      <ToggleButtonGroup
        color="primary"
        value={value}
        exclusive
        onChange={(e) => changeHandler(e, setErrors, setForm, form)}
        aria-label="Platform"
      >
        {optionsArray.map((option, index) => (
          <ToggleButton 
            key={index} 
            value={option}
            name={name}
            sx={{
              width: buttonWidth,
            }}
          >
            {option}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  )
}